module.exports = __webpack_public_path__ + "static/media/minus.23b64a97.svg";